import {UserId} from '@legit.health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const PRACTICIONER_DELETED_EVENT = 'practitioner.deleted';

export interface PractitionerDeletedEvent extends DomainEvent {
  practitionerId: UserId;
}

export function createPractitionerDeletedEvent(practitionerId: UserId): PractitionerDeletedEvent {
  return Object.freeze({
    name: PRACTICIONER_DELETED_EVENT,
    practitionerId
  });
}
